export const REQ_CHANGE_PW = 'REQ_CHANGE_PW'
export const CHANGE_PW_SUCCESS = 'CHANGE_PW_SUCCESS'
export const CHANGE_PW_ERROR = 'CHANGE_PW_ERROR'
export const CLEAR_DELETE_PW = "CLEAR_DELETE_PW"